import { TenantType } from '@/config/constants/enums';

/**
 * Public paths to the role-specific product demo videos (static assets served
 * from `public/videos`). Shared by the marketing homepage demo and every
 * pre-registration landing page so the sources live in exactly one place.
 */
export const DEMO_VIDEO_SOURCES: Record<TenantType, string> = {
    [TenantType.SUPPLIER]: '/videos/supplier-demo.mp4',
    [TenantType.AGENT]: '/videos/agent-demo.mp4',
};
